class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    if(location.hash === '#cart-open') {
      this.open();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() {
    super();

    this.throttledSellingPlanClick = throttle(this.handleSellingPlanClick.bind(this), 1000)
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    
    this.dropdowns = this.querySelectorAll(".cart-subscription-dropdown");
    if(this.dropdowns?.length) {
      this.dropdowns.forEach(this.initDropdown.bind(this));
    }
    this.activeDropdown = null;

    document.addEventListener("click", this.handleOutsideClick);
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  initDropdown(dropdown) {
    if(!dropdown) return;

    const trigger = dropdown.querySelector(".cart-subscription-dropdown-trigger");
    const itemsWrapper = dropdown.querySelector(".cart-subscription-dropdown-items-wrapper");
    const items = dropdown.querySelector(".cart-subscription-dropdown-items");

    dropdown.itemsWrapper = itemsWrapper;
    dropdown.fullHeight = items.offsetHeight;
    dropdown.isOpen = false;

    trigger.addEventListener("click", (event) => this.toggleDropdown(event,dropdown));

    items.addEventListener("click", this.throttledSellingPlanClick);
  }

  toggleDropdown(event, dropdown) {
    event.preventDefault();
    event.stopPropagation();
    if(dropdown.classList.contains("disabled")) return;

    dropdown.isOpen ? this.closeDropdown(dropdown) : this.openDropdown(dropdown);
  }

  openDropdown(dropdown) {
    if (this.activeDropdown && this.activeDropdown !== dropdown) {
      this.closeDropdown(this.activeDropdown);
    }

    dropdown.isOpen = true;
    dropdown.classList.add("active");
    dropdown.itemsWrapper.style.height = `${dropdown.fullHeight}px`;

    this.activeDropdown = dropdown;
  }

  closeDropdown(dropdown) {
    dropdown.isOpen = false;
    dropdown.classList.remove("active");
    dropdown.itemsWrapper.style.height = "0px";

    if (this.activeDropdown === dropdown) {
      this.activeDropdown = null;
    }
  }

  handleSellingPlanClick(e) {
    if(e.target.tagName !== 'SPAN') return;
    e.preventDefault();
    e.stopPropagation();

    const index = e.target.dataset.index;
    const sellingPlanQty = e.target.dataset.sellingPlanQty;
    const sellingPlanId = e.target.dataset.sellingPlanId;

    const selectedPlanId = e.target.closest('.cart-subscription-dropdown')?.dataset?.selectedPlanId;

    if(selectedPlanId == sellingPlanId) return;

    const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
    cartItems.updateQuantity(
      index,
      sellingPlanQty,
      "subscription",
      sellingPlanId
    );

  }

  handleOutsideClick(e) {
    if (!this.activeDropdown) return;

    const activeWrapper = this.activeDropdown.querySelector(".cart-subscription-dropdown-items-wrapper");
    if (!activeWrapper.contains(e.target)) {
      this.closeDropdown(this.activeDropdown);
    }
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleOutsideClick);
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

if (!customElements.get("subscription-toggle")) {
  customElements.define(
    "subscription-toggle",
    class extends HTMLElement {
      constructor() {
        super();

        this.firstAvailableSellingPlanId = this.dataset.sellingPlanId;
        this.input = this.querySelector("input[name='subscription']");
        this.isChecked = this.input.checked;
        this.index = this.dataset.index;
        this.sellingPlanQty = this.dataset.sellingPlanQty;

        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.debouncedCartUpdate = debounce((checked) => {
          this.updateCartQuantity(checked);
        }, 300);
      }
      connectedCallback() {
        this.input.addEventListener("change", this.inputChangeHandler);
      }

      inputChangeHandler(e) {
        e.preventDefault();
        e.stopPropagation();

        this.debouncedCartUpdate(e.target.checked);
      }

      updateCartQuantity(newChecked) {
        if(this.isChecked == newChecked) return;

        const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
        cartItems.updateQuantity(
          this.index,
          this.sellingPlanQty || 1,
          "subscription",
          ...(this.input.checked ? [this.firstAvailableSellingPlanId] : ["clear"])
        );
      }
    }
  );
}

if(!customElements.get("measuring-glass-toggle")) {
  customElements.define("measuring-glass-toggle", class extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector("input[name='measuring-glass']");
      this.isChecked = this.input.checked;
      this.inputChangeHandler = this.inputChangeHandler.bind(this);
      this.debouncedCartUpdate = debounce((checked) => {
        this.updateCartQuantity(checked);
      }, 300);
    }

    connectedCallback() {
      this.input.addEventListener("change", this.inputChangeHandler);
    }

    inputChangeHandler(e) {
      e.preventDefault();
      e.stopPropagation();

      this.debouncedCartUpdate(e.target.checked);
    }

    updateCartQuantity(newChecked) {
      if(this.isChecked == newChecked) return;
      
      const lineItem = this.closest(".cart-item");
      const quantity = lineItem.querySelector(".quantity__input")?.value || lineItem.querySelector(".cart-item__subscription-quantity")?.dataset.qty;

      const index = this.dataset.index;
      const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");

      cartItems.updateQuantity(
        index,
        quantity,
        "measuring-glass",
        null,
        newChecked || 'clear'
      );
    }
  });
}
